import React, {PropTypes as T} from 'react';
import Modal, {ModalContent} from '../../common/modal';
import WarningHeader from '../../common/modal/closeable_icon_warning_header';
import TU from '../../common/tu';
import SadTicketIcon from '../../common/icons/icon_sad_ticket';

export default class SeatmapGeneralErrorModal extends React.Component {
  static propTypes = {
    onClose: T.func,
    translations: T.object
  };

  static defaultProps = {
    onClose: Function.prototype
  };

  state = {
    isOpen: true
  };

  closeModal = () => {
    this.setState({
      isOpen: false
    });
    setTimeout(this.props.onClose, 300);
  };

  render () {
    const trans = this.props.translations;
    return (
      <Modal dataComponent="general-error-modal" isOpen={this.state.isOpen} onClose={this.closeModal}>
        <WarningHeader onClose={this.closeModal} title={trans.GENERIC_ERROR_HEADER} />
        <ModalContent>
          <SadTicketIcon className="modal__sad_ticket_icon" />
          <TU text={trans.GENERIC_ERROR_INFO} />
        </ModalContent>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/errors/general_error.js